angular.module('mtic.components.notifications', [])
angular.module('mtic.components.notifications')
.directive('notificationsList', function ($log, EventManager, $timeout, LocaleService, TeacherDataService, language,api, userAccount, notificationService, apiTranslationService, ModuleFilter, $q, StudentDataService) {
  return {
    templateUrl: 'template.html',
    scope: {
    },
    link: function (scope) {
      var eventManager = new EventManager('notificationSystem');
      scope.notifications_list = [];
      var dismissed_list = [];
      var eligbleSeenNotifications = [];
      scope.getTranslation = function(slug){
        return language.get(slug);
      }
      function init(){
        $q.all([
          api.getUserNotifications(userAccount.getData().user_id),
          apiTranslationService.getTranslationPack('mtic_notifications')
        ]).then(function([notifications, translations]){
          // scope.show_notifications = true;
          // $log.log('raw notifications : ' , notifications);
          scope.notifications_list = process_notifications(notifications);
          $log.log('got user notifications : ' , scope.notifications_list);
          // $log.log('got eligbleSeenNotifications : ' , eligbleSeenNotifications)
          updateHiddenStatus();
          //Added a slight timeout to avoid flashing notifications that are not hidden in time
          $timeout(function(){
            checkPending();
          }, 300)
        })
      }
      scope.getApiTranslation = function (id) {
        return apiTranslationService.getTranslation(id);
      }

      function process_notifications(list, mapping){

        var modified = [];
        dismissed_list = [];
        var reset_mapping = mapping || {};
        var reprocess = false;

        list.forEach(function(entry){

          var notificationId = entry.id;

          if(ModuleFilter.checkNotificationAvailable(entry.notification_data)){
            if(entry.notification_type === 'p2p'){
              var p2p_list = _.map(entry.NotificationStateLogs, function(p2p_entry){
                return {
                  id: notificationId,
                  instance_id: p2p_entry.id,
                  name: entry.notification_slug,
                  is_forced: entry.is_forced,
                  is_repeatable: entry.is_repeatable,
                  dismissed: p2p_entry.dismissed,
                  from_user: p2p_entry.from_user_id,
                  log_state: p2p_entry.log_state,
                  release_date: entry.notification_type==='p2p' ? p2p_entry.created_at : entry.display_release_date,
                  type: entry.notification_type,
                  archived: p2p_entry.hidden
                }
              })
              modified = modified.concat(p2p_list)
            }
            else{

              var isDismissed = false;
              var isSeen = false;
              var notiStateLog = entry.NotificationStateLogs[0];
              var notiStateLogData;
              var isNotiHidden;
              var gracePeriodDays;
              var ignoreLimit;
              var new_ignore_count;
              if (notiStateLog){
                notiStateLogData = notiStateLog.log_state;
                isNotiHidden = notiStateLog.hidden;
              }
              if (entry.notification_data){
                gracePeriodDays = entry.notification_data.grace_period_days;
                ignoreLimit = entry.notification_data.ignore_limit;
              }

              var seen_date;
              var latest_entry;
              //filtering out old logs when a yearly reset is used
              if(entry.notification_data && entry.notification_data.yearly_reset){
                entry.NotificationStateLogs = _.filter(entry.NotificationStateLogs, function(cur_log){
                  return new Date(cur_log.updated_at) > new Date(entry.notification_data.yearly_reset);
                })
              }

              _.each(entry.NotificationStateLogs, function(log){
                isDismissed = isDismissed || log.dismissed;

                if (!latest_entry || new Date(log.created_at) > new Date(latest_entry.created_at)) {
                  latest_entry = log;
                }
                if(log.log_state && log.log_state.isSeenDuringGrace){
                  seen_date = new Date(log.updated_at);
                }
                isSeen = true;
              });


              //if the notification is dismissed and reset settings is not undefined, check if it should be reset
              if (latest_entry && latest_entry.dismissed && entry.notification_data && entry.notification_data.reset_settings && !latest_entry.log_state.is_reset) {
                //the notification_data's reset_settings has a reset_by slug which indicates the notification this one is reset by, find it
                var reset_entry = _.find(list, function(list_entry){
                  return list_entry.notification_slug === entry.notification_data.reset_settings.reset_by;
                })

                if(reset_entry && reset_entry.NotificationStateLogs){
                  var reset_dismiss_date;
                  _.each(reset_entry.NotificationStateLogs, function(log){
                    //if the first_element_reset flag is present, then it doesn't require the dependant notification to have been reset itself, otherwise it does
                    if(log.dismissed && ((log.log_state && log.log_state.is_reset && !entry.notification_data.reset_settings.first_element_reset) || ((!log.log_state || !log.log_state.is_reset) && entry.notification_data.reset_settings.first_element_reset))){
                      reset_dismiss_date = new moment(log.dismissed_at);
                    }
                  })

                  if(reset_dismiss_date){
                    reset_dismiss_date.add(entry.notification_data.reset_settings.reset_days , 'days');
                    //if today is after the calculated reset date, reset the notification
                    if(reset_dismiss_date < new moment()){
                      isDismissed = false;
                      entry.should_reset = true;
                      if(reset_dismiss_date < new moment().add(-1, "day")){
                        //if more than one day has passed since the reset date, notification is mandatory
                        entry.is_mandatory = true;
                      }
                      //$log.log('SHOULD RESET NOW : ', reset_dismiss_date, entry.is_mandatory)
                    }
                  }
                }
              }

              if (gracePeriodDays && !isSeen){
                eligbleSeenNotifications.push(notificationId);
              }

              var gracePeriodOver = false;
              var force_optional = false;
              var cur_date = new Date();

              //checking if grace period is over
              if(!isDismissed && seen_date && gracePeriodDays && !entry.should_reset){
                var unlockedByEntry = _.find(list, function(notif){
                  return entry.unlocked_by_notifications.indexOf(notif.notification_slug) > -1;
                });

                seen_date.setDate(seen_date.getDate() + gracePeriodDays);
                if(seen_date < cur_date){
                  gracePeriodOver = true;
                }

                // adding 1 day to force mandatory when show_after_grace_period flag is used
                var postGracePeriodDate = _.clone(seen_date);
                postGracePeriodDate.setDate(postGracePeriodDate.getDate() + 1);

                var mandatoryDatePassed = postGracePeriodDate > cur_date;

                if (unlockedByEntry && unlockedByEntry.NotificationStateLogs && unlockedByEntry.NotificationStateLogs.length > 0) {
                  seen_date = new Date(unlockedByEntry.NotificationStateLogs[0].dismissed_at);
                  seen_date.setDate(seen_date.getDate() + gracePeriodDays);
                  if(seen_date < cur_date){
                    gracePeriodOver = true;
                  }

                  if (entry.NotificationStateLogs) {
                    var entryCreatedAt = new Date(entry.NotificationStateLogs[0].created_at);
                    entryCreatedAt.setDate(entryCreatedAt.getDate() + 1);
                    mandatoryDatePassed = entryCreatedAt > cur_date;
                  }
                }

                if (entry.notification_data && entry.notification_data.show_after_grace_period && mandatoryDatePassed) {
                  force_optional = true;
                }
              }else if(!isDismissed && ignoreLimit){      
                new_ignore_count = latest_entry && latest_entry.log_state.ignored_count ? latest_entry.log_state.ignored_count : 1;

                if(latest_entry && latest_entry.log_state.ignored_count && latest_entry.log_state.ignored_date){
                  if(moment(latest_entry.log_state.ignored_date, 'MM-DD-YYYY').format('MM-DD-YYYY') !== moment().format('MM-DD-YYYY')){
                    if(latest_entry.log_state.ignored_count >= ignoreLimit){
                      //if ignore count is at the limit make it mandatory
                      entry.is_forced = true;
                      new_ignore_count = null;
                    }else{
                      //if ignore count is less than limit increase it
                      new_ignore_count++;
                      api.logNotificationState(userAccount.getData().user_id, entry.id, {ignored_count: new_ignore_count, ignored_date: moment().format('MM-DD-YYYY')}, true).then(function(){});
                    }
                  }
                }else{
                  api.logNotificationState(userAccount.getData().user_id, entry.id, {ignored_count: 1, ignored_date: moment().format('MM-DD-YYYY')}, true).then(function(){});
                }
              }

              modified.push({
                id: entry.id,
                name: entry.notification_slug,
                is_forced: entry.is_forced || (gracePeriodOver && !force_optional) || entry.is_mandatory,
                is_repeatable: entry.is_repeatable,
                unlocked_by: entry.unlocked_by_notifications,
                dismissed: isDismissed,
                release_date: entry.display_release_date,
                type: entry.notification_type,
                log_state: notiStateLogData,
                hidden: entry.unlocked_by_notifications && entry.unlocked_by_notifications.length > 0 && !isDismissed,
                show_when_available: entry.notification_data && entry.notification_data.show_when_available_only,
                hidden_by_flag: !gracePeriodOver && entry.notification_data && entry.notification_data.show_after_grace_period && !isDismissed && !entry.should_reset,
                archived: isDismissed && isNotiHidden,
                resource: entry.Resource,
                options: entry.notification_data,
                should_reset: entry.should_reset,
                ignore_count: ignoreLimit ? ignoreLimit - new_ignore_count : null
              })
              if(isDismissed){
                dismissed_list.push(entry.notification_slug)
              }
              if(entry.notification_slug === "cycle_prompt" && entry.NotificationStateLogs && entry.NotificationStateLogs[0]){
                checkC4Status(entry.NotificationStateLogs[0].log_state)
              }
            }
          }
        })

        if(reprocess){
          return process_notifications(list, reset_mapping);
        }else{
          return modified;
        }
      }

      function updateHiddenStatus(){
        var reset = false;
        scope.notifications_list.forEach(function(notification){
          if(notification.unlocked_by && notification.unlocked_by.length > 0){
            var hidden = false;
            notification.unlocked_by.forEach(function(locker){
              if(dismissed_list.indexOf(locker) === -1 || (!scope.is_c4_member && notification.options.c4_users_only)){
                hidden = true;
              }
            })
            if(!notification.hidden && hidden){
              dismissed_list.splice(dismissed_list.indexOf(notification.name), 1)
              reset = true;
            }
            notification.hidden = hidden && !notification.should_reset;
          }
          if(!notification.hidden && eligbleSeenNotifications.indexOf(notification.id) > -1){
            api.logNotificationState(userAccount.getData().user_id, notification.id, {isSeenDuringGrace:true}).then(function(){
              eligbleSeenNotifications.splice(eligbleSeenNotifications.indexOf(notification.id), 1)
            });
          }

          notification.hidden = notification.hidden || notification.hidden_by_flag;
          // the show_when_available flag allows the notification to be displayed only when it's available
          if(notification.show_when_available){
            notification.hidden = notification.hidden || (notification.dismissed && !notification.is_repeatable);
          }
        })
        if(reset){
          updateHiddenStatus();
        }
      }
      eventManager.listen('login:first', function(){
        init();
      })

      scope.attempt_to_hide = function(){
        if(checkPending(true)){
           document.querySelector("#notifications_box").classList.add("apply-shake");
           scope.highlight_forced = true;
           $timeout(function(){
             scope.highlight_forced = false;
             document.querySelector("#notifications_box").classList.remove("apply-shake");
           }, 800)
        }else{
          scope.showMessagePanel = false;
        }
      }
      scope.renderMomentDate = function(date){
        return moment(date).locale(language.getMomentLocale()).format('D MMM YYYY');
      }
      scope.open_notification = function(notification){
        if(!notification.is_repeatable && notification.dismissed){
          return;
        }
        // $log.log('opening notification : ' , notification)
        scope.current_notification = notification

        if(notification.options && notification.options.language){
          language.setAvailableOptions(notification.options.language)
        }
        if(notification.type === 'system' || notification.type === 'p2p'){
          scope.notificationView = notification.name;
          scope.dismissed = notification.dismissed;
        }else if(notification.type === 'iframe_message'){
          if(!eventManager.getResourceSession() || (eventManager.getResourceSession() && window.confirm(scope.getTranslation("mtic_close_opened_lesson")))) {
            if (eventManager.getResourceSession()){
              eventManager.broadcast('module:close:resource')
            }
            scope.current_notification.resource.notification_slug = scope.current_notification.name;
            scope.setResource(scope.current_notification.resource, scope.current_notification.should_reset);
            scope.notificationView = notification.type;
            scope.dismissed = notification.dismissed;

            scope.iframe_style = {"show_close_button": !notification.is_forced};
            if (notification.options.style) {
              scope.iframe_style.width = notification.options.style.width;
              scope.iframe_style.height = notification.options.style.height;
            }
          }
        }else if(notification.type === 'resource'){
          scope.notificationView = 'resource_notification';
          scope.resource_data = {
              hostUrl: notification.resource.content.hostUrl,
              module_id: 57,
              slug: notification.resource.slug,
              id: notification.resource.id,
              class_id: 99999,
              content: notification.resource.content
          }
        }
        eventManager.broadcast('user:view:notification', notification.name)
        scope.show_notifications = false;
      }

      function checkPending(attempt_dismiss){
        var show = false;
        //the popup flag is used to hide a notification from the notificaion list but immediately open it instead
        var popup_available = false;
        scope.notifications_list.forEach(function(item){
          if(!attempt_dismiss && !item.dismissed && !item.hidden && (!item.options || !item.options.popup)){
            show = true;
          }else if(attempt_dismiss && !item.dismissed && !item.hidden && item.is_forced && (!item.options || !item.options.popup)){
            show = true;
          }else if(!item.dismissed && !item.hidden && item.options && item.options.popup){
            item.hidden = true;
            popup_available = item;
          }
        })
        scope.show_notifications = show && !popup_available;
        if(window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened){
          scope.show_notifications = false;
          return false;
        }
        if(popup_available){
          scope.open_notification(popup_available);
        }
        return show;
      }

      scope.archiveNotification = function(item){
        scope.show_archive_confirmation = true;
        scope.archive = function(){
          scope.archiving = true;
          api.archiveNotification(userAccount.getData().user_id, item.id, item.instance_id)
          .then(function(){
            scope.archiving = false;
            item.archived = !item.archived;
            scope.show_archive_confirmation = false;
            scope.showArchivedNotifications = false;
          }).catch(function(){
            scope.archiving = false;
          })
        }
      }

      eventManager.listen('resource:score:submitted', function(e, data){
        if(scope.resource_data && data.slug === scope.resource_data.slug){
          var dont_hide = true;
          if(scope.resource_data.resource_type === 'embedded_notification'){
            eventManager.broadcast('module:close:resource');
            dont_hide = false;
          }
          notificationService.dismissNotification(null, dont_hide)
        }
      })

      eventManager.listen('hide-notification-iframe', function(){
        scope.notificationView = null;
        scope.show_notifications = false;
      });

      function checkC4Status(state){
        scope.is_c4_member = scope.is_c4_member || (userAccount.getData().role.isTeacher ? (state.class_choice_c3_1 || state.class_choice_c3_2 || state.class_choice_c4_1 || state.class_choice_c4_2) : (state.class_choice_c4_1 || state.class_choice_c4_2))
      }

      notificationService.showNotifications = function(){
        scope.show_notifications = true;
      }
      notificationService.dismissNotification = function(log_state, dont_hide, dont_log){
        $log.log('dismiss: ' , scope.current_notification);


        if (scope.current_notification.should_reset) {
          if(!log_state && scope.current_notification.log_state){
            log_state = scope.current_notification.log_state;
          }
          log_state.is_reset = true;
        }
        if(scope.current_notification && (!scope.current_notification.dismissed || log_state) && !dont_log){
          api.dismissNotification(userAccount.getData().user_id, scope.current_notification.id, log_state, scope.current_notification.instance_id)
          .then(function(dismissed){
            scope.current_notification.dismissed = true;
            scope.notificationView = dont_hide ? scope.notificationView : null;
            dismissed_list.push(scope.current_notification.name);
            eventManager.broadcast('user:dismiss:notification', scope.current_notification.name)
            if(scope.current_notification.name === "cycle_prompt" && log_state){
              checkC4Status(log_state);
            }
            updateHiddenStatus();
            checkPending();
          })
        }else{
          scope.notificationView = dont_hide ? scope.notificationView : null;
          checkPending();
        }
      }
      notificationService.isNotificationActive = function(){
        return scope.notificationView && scope.current_notification && scope.current_notification.is_forced && !scope.current_notification.dismissed;
      }
      notificationService.hideNotifications = function(){
        scope.notificationView = null;
        checkPending();
      }

      scope.message = {
        sending: false,
        user_id: null,
        text: '',
        sendMessage: function(){
          if(!scope.message.user_id || scope.message.text === '' || isNaN(scope.message.user_id)){
            window.alert('Please enter a valid user and message!')
            return;
          }
          scope.message.sending = true;
          api.postUserNotification('user_message', scope.message.user_id, userAccount.getData().user_id, {message: scope.message.text})
          .then(function(msg){
            scope.message.sending = false;
            scope.message.success = true;
            $timeout(function(){
              scope.message.success = false;
              scope.showMessagePanel = false;
            }, 1000)
          })
          .catch(function(err){
            scope.message.sending = false;
          })
        }
      }

      scope.setResource = function(data, is_follow_up){
        scope.resource_data = {
          hostUrl: data.hostUrl,
          module_id: 57,
          slug: data.slug,
          id: data.id,
          class_id: 99999,
          resource_type: data.resource_type ? data.resource_type : 'baseline',
          notification_slug: data.notification_slug,
          is_follow_up: is_follow_up,
          is_forced: scope.current_notification.is_forced
        }
        eventManager.broadcast('module:open:resource', scope.resource_data)
        scope.notificationView = 'resource_notification'
      }
      eventManager.listen('module:close:resource', function(){
        if(scope.resource_data && scope.notificationView === 'resource_notification'){
          scope.notificationView = null;
        }
      })
    }
  }
})
